import Util from 'util/util';

export function exportShareLinks(groupModel) {

    const rows = [
        [window.i18n.gettext('Chapter'), window.i18n.gettext('Section'), window.i18n.gettext('Activity'), window.i18n.gettext('Link')]
    ]
    for (const chapter of groupModel.chapters) {
        rows.push([
            chapter.get('name'),
            '',
            '',
            getShareURL(chapter)
        ])

        for (const section of chapter.sections) {
            rows.push([
                chapter.get('name'),
                section.get('name'),
                '',
                getShareURL(section)
            ])

            for (const activity of section.activities) {
                if (activity.get('type') === 'adaptive_student') {
                    continue
                }

                rows.push([
                    chapter.get('name'),
                    section.get('name'),
                    activity.get('name'),
                    getShareURL(activity)
                ])
            }
        }
    }

    const csv = rows
        .map(row => row.map(escapeCSVValue).join(';'))
        .join('\n')

    Util.createFileDownload('data:text/csv;charset=utf-8,' + encodeURIComponent(csv), 'share-links.csv')
}

function escapeCSVValue(value) {
    const str = value.toString()
    if (/[";\n\r]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`
    }
    return str
}

function getShareURL(model) {
    return `${document.location.origin}/${model.constructor.pluralType}/share/${model.getSourceId() || model.id}`
}
